export const toPascalCase = (str) => {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Split camel case
        .replace(/[^a-zA-Z0-9 ]/g, ' ') // Remove special characters
        .replace(/\s+(.)/g, (_, chr) => chr.toUpperCase()) // Convert first letter after spaces to uppercase
        .replace(/\s/g, '') // Remove spaces
        .replace(/^(.)/, (_, chr) => chr.toUpperCase()); // Convert first letter to uppercase
};